import { AfterViewInit, DestroyRef, Directive, ElementRef, Injector, afterNextRender, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatAutocomplete } from '@angular/material/autocomplete';
import { MatSelect } from '@angular/material/select';
import { AppVisualContextService } from '../services/app-visual-context.service';

/** Painéis do CDK saem da árvore do controle; conservam a identidade de sua origem. */
@Directive({ selector: 'mat-select, mat-autocomplete', standalone: true })
export class MaterialAccentDirective implements AfterViewInit {
  private readonly element = inject(ElementRef<HTMLElement>);
  private readonly context = inject(AppVisualContextService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly injector = inject(Injector);
  private readonly select = inject(MatSelect, { optional: true, self: true });
  private readonly autocomplete = inject(MatAutocomplete, { optional: true, self: true });

  ngAfterViewInit(): void {
    this.select?.openedChange.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(open => {
      if (open) this.applyContext(this.select?.panel?.nativeElement);
    });
    this.autocomplete?.opened.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      // O evento opened precede a atualização da ViewChild do painel no Material 17.
      afterNextRender(() => this.applyContext(this.autocomplete?.panel?.nativeElement), { injector: this.injector });
    });
  }

  private applyContext(panel?: HTMLElement): void {
    const pane = panel?.closest('.cdk-overlay-pane');
    if (!pane) return;
    const accent = this.context.classForAccent(this.context.accentForElement(this.element.nativeElement));
    for (const name of Array.from(pane.classList)) {
      if (name.startsWith('app-accent-')) pane.classList.remove(name);
    }
    pane.classList.add(accent);
  }
}
